import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

const BRAND_ITEM_SCHEMA = [
  { key: "logo", label: "Logo Image", type: "image" as const },
  { key: "name", label: "Brand Name", type: "string" as const },
  { key: "link", label: "Brand URL", type: "string" as const },
];

export const schema: ComponentSchema = {
  type: "brands",
  label: "Brand Logos",
  description: "Display partner or brand logos in a grid or auto-scrolling ticker.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Logo Grid / Ticker",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        {
          key: "layout",
          label: "Layout",
          type: "select",
          options: [
            { label: "Grid", value: "grid" },
            { label: "Auto-scroll Ticker", value: "ticker" },
          ],
          default: "grid",
        },
        { key: "items", label: "Brand Items", type: "array", itemSchema: BRAND_ITEM_SCHEMA },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
